/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Warm_Fox_TuneInputs */

const en_quick_warm_fox_tune = /** @type {(inputs: Quick_Warm_Fox_TuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment Settings`)
};

const de_quick_warm_fox_tune = /** @type {(inputs: Quick_Warm_Fox_TuneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment-Einstellungen`)
};

/**
* | output |
* | --- |
* | "Segment Settings" |
*
* @param {Quick_Warm_Fox_TuneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quick_warm_fox_tune = /** @type {((inputs?: Quick_Warm_Fox_TuneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Warm_Fox_TuneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quick_warm_fox_tune(inputs)
	return de_quick_warm_fox_tune(inputs)
});